function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The Progress component behaves similar to a HTML progress element and is
 * used to represent a progress state for an activity such as a trophy or UAM.
 *
 * - [Mobile Design System Progress](https://confluence.sie.sony.com/display/PPRC1/Progress+Bars)
 * - [DIG20 ATLAS spec](https://atlas.np.tools.playstation.net/design/4cba61de-7410-44bf-b7ce-eb6d9b510a9d/2?bounds=-0.266,0.842,1.533,0.932&rev=2&x=475.95&y=5057.51)
 * - [MDN docs on progress](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/progress)
 *
 * ## Related Components
 * - [CircularProgress](../CircularProgress/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Progress
 *   value={50}
 *   max={100}
 *   title="Progress Title"
 *   status="Connecting to Console"
 *   completeness="percent"
 *   cta={<Button>Some CTA</Button>}
 * />
 * ```
 *
 * ## Props
 */

var Progress = /*#__PURE__*/function (_PureComponent) {
  _inherits(Progress, _PureComponent);

  var _super = _createSuper(Progress);

  function Progress(props) {
    var _this;

    _classCallCheck(this, Progress);

    _this = _super.call(this, props);
    var id = props.id;

    if (!id) {
      var count = (Progress.count || 0) + 1;
      Progress.count = count;
      _this.id = "progress-".concat(count);
    }

    return _this;
  }

  _createClass(Progress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          id = _this$props.id,
          value = _this$props.value,
          max = _this$props.max,
          className = _this$props.className,
          title = _this$props.title,
          status = _this$props.status,
          completeness = _this$props.completeness,
          cta = _this$props.cta,
          statusType = _this$props.statusType,
          disabled = _this$props.disabled;
      var isComplete = value >= max;
      var percentComplete = Math.round(value / Math.max(max, value) * 100);

      var _Progress$getClassNam = Progress.getClassName({
        className: className,
        isComplete: isComplete,
        statusType: statusType,
        disabled: disabled
      }),
          root = _Progress$getClassNam.root,
          titleClass = _Progress$getClassNam.title,
          statusClass = _Progress$getClassNam.status,
          percentClass = _Progress$getClassNam.percent,
          progressBar = _Progress$getClassNam.progressBar,
          progressValue = _Progress$getClassNam.progressValue;

      var useId = id || this.id;
      return /*#__PURE__*/React.createElement("span", {
        "data-qa": qa,
        className: root
      }, (title || completeness) && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-line-repel psw-fill-x"
      }, /*#__PURE__*/React.createElement("label", {
        "data-qa": "".concat(qa, "#title"),
        htmlFor: useId,
        className: titleClass
      }, title), completeness && /*#__PURE__*/React.createElement("label", {
        "data-qa": "".concat(qa, "#completeness"),
        htmlFor: useId,
        className: percentClass
      }, completeness === 'percent' ? "".concat(percentComplete, "%") : completeness)), /*#__PURE__*/React.createElement("div", {
        "aria-valuemax": max,
        "aria-valuemin": "0",
        "aria-valuenow": value,
        className: progressBar,
        "data-qa": "".concat(qa, "#progress"),
        id: id,
        role: "progressbar"
      }, /*#__PURE__*/React.createElement("div", {
        className: progressValue,
        style: {
          transformOrigin: '0 0',
          transform: "scaleX(".concat(percentComplete / 100, ")")
        }
      })), (status || cta) && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-line-repel psw-fill-x"
      }, /*#__PURE__*/React.createElement("label", {
        "data-qa": "".concat(qa, "#status"),
        htmlFor: useId,
        className: statusClass
      }, status), /*#__PURE__*/React.createElement("div", {
        className: "psw-l-line-left psw-l-space-x-3 psw-m-sub-r-4"
      }, cta && /*#__PURE__*/cloneElement(cta, {
        qa: "".concat(qa, "#cta"),
        ctaType: 'tertiary',
        size: 'small',
        disabled: disabled
      }))));
    }
  }]);

  return Progress;
}(PureComponent);

Progress.getClassName = function (_ref) {
  var className = _ref.className,
      isComplete = _ref.isComplete,
      statusType = _ref.statusType,
      disabled = _ref.disabled;
  return {
    root: cx('psw-progress', disabled && 'psw-is-disabled', {
      'psw-is-complete': isComplete
    }, 'psw-fill-x', 'psw-l-stack-left', "psw-".concat(statusType), className),
    title: cx('psw-progress-title', 'psw-h4', 'psw-truncate-text-1', 'psw-l-space-x-xs', disabled && 'psw-c-t-disabled'),
    percent: cx('psw-progress-percent', 'psw-t-secondary', "psw-c-t-".concat(disabled ? 'disabled' : '2')),
    status: cx('psw-progress-status', 'psw-t-secondary', "psw-c-t-".concat(disabled ? 'disabled' : '2')),
    progressBar: cx('psw-progress-bar', 'psw-fill-x', 'psw-m-y-3', 'psw-r-pill'),
    progressValue: cx('psw-progress-value', 'psw-r-pill', 'psw-p-t-2', disabled && 'psw-dimmed')
  };
};

Progress.useClassNames = function (x) {
  Progress.classNames = x;
};

Progress.defaultProps = {
  qa: '',
  id: '',
  value: 0,
  max: 100,
  className: '',
  title: '',
  status: '',
  completeness: null,
  cta: null,
  statusType: 'active',
  disabled: false
};
Progress.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Element Id to associate all labels to
   */
  id: PropTypes.string,

  /**
   * The progress value (out of max)
   */
  value: PropTypes.number,

  /**
   * The max value of the progress
   */
  max: PropTypes.number,

  /**
   * The progress title string
   */
  title: PropTypes.string,

  /**
   * The progress status string
   */
  status: PropTypes.string,

  /**
   * The cta associated with the progress, used to cancel or view more details
   */
  cta: PropTypes.node,

  /**
   * The value associated with the displayed progress. If percent is passed the percentage
   * will be calculated and displayed
   */
  completeness: PropTypes.oneOf([PropTypes.string, 'percent']),

  /**
   * The visual style of the progress value, defaults to 'active'
   */
  statusType: PropTypes.oneOf(['active', 'error', 'queued']),

  /**
   * Whether the Progress should be presented as disabled
   */
  disabled: PropTypes.bool
};
cx = classNamesFor(Progress);
export default Progress;